import React from 'react';
import useCollapse from 'react-collapsed';

interface ICollapsibleSection {
    className?: string;
    style?: React.CSSProperties;
    title: string;
}

const CollapsibleSection: React.FC<ICollapsibleSection> = (props) => {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({ defaultExpanded: true });

    const barProps: React.CSSProperties = {
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
    };

    return (
        <>
            <div className={`dlc-section-bar`} style={{ ...barProps, ...props.style }} {...getToggleProps()}>
                <div
                    className={`collapse-panel collapse-panel--${isExpanded ? 'close' : 'open'}`}
                    // {...getToggleProps()}
                    style={{ outline: 'none', cursor: 'pointer' }}
                >
                    <div style={{ marginLeft: '1rem', display: 'inline', fontSize: '1.5em' }}>{props.title}</div>
                </div>
            </div>
            <div {...getCollapseProps()} className={`ml-2 mr-2 ${props.className}`}>
                {props.children}
            </div>
        </>
    );
};

CollapsibleSection.displayName = 'CollapsibleSection';

export default CollapsibleSection;



// WEBPACK FOOTER //
// ./src/components/common/CollapsibleSection.tsx